var _filter, _clipPath, _clipPath2, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWavenetConnectedWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "200px",
    height: "160px",
    viewBox: "0 0 199 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 199,
    height: 160,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.988235,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 199,
    height: 160
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface5",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(91.764706%,38.431373%,9.803922%)",
      fillOpacity: 1
    },
    d: "M -0.046875 -0.046875 C 2.785156 -0.046875 5.617188 -0.046875 8.449219 -0.046875 C 35.472656 53.285156 62.496094 106.617188 89.519531 159.953125 C 86.6875 159.953125 83.855469 159.953125 81.023438 159.953125 C 54.023438 106.695312 27 53.457031 -0.046875 0.238281 C -0.046875 0.144531 -0.046875 0.046875 -0.046875 -0.046875 Z M -0.046875 -0.046875 "
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 199,
    height: 160,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.992157,
      stroke: "none"
    }
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 199,
    height: 160
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface8",
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,100%,99.607843%)",
      fillOpacity: 1
    },
    d: "M 198.953125 0.238281 C 198.953125 0.304688 198.953125 0.367188 198.953125 0.429688 C 182.0625 33.714844 165.144531 66.992188 148.199219 100.261719 C 137.5625 79.332031 126.898438 58.414062 116.210938 37.507812 C 105.644531 58.460938 95.027344 79.378906 84.363281 100.261719 C 67.375 66.96875 50.410156 33.660156 33.46875 0.335938 C 40.046875 0.207031 46.621094 0.207031 53.1875 0.335938 C 63.597656 21.671875 74.003906 43.003906 84.414062 64.335938 C 94.988281 43.464844 105.585938 22.613281 116.210938 1.773438 C 126.898438 22.613281 137.5625 43.464844 148.199219 64.335938 C 158.542969 43.003906 168.890625 21.667969 179.234375 0.335938 C 185.800781 0.238281 192.371094 0.207031 198.953125 0.238281 Z M 198.953125 0.238281 "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface5",
    mask: "url(#mask0)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface8",
    mask: "url(#mask1)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavenetConnectedWhite);
export default __webpack_public_path__ + "static/media/Wavenet-Connected-White.30666d80961ced961880877c83a1ba35.svg";
export { ForwardRef as ReactComponent };